import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckoutModule } from '@checkout';
import { NotifyHeightDirective } from '../height.directive';
import { PaymentResponseWrapperComponent } from './payment-response-wrapper.component';
import { PaymentTransferWrapperComponent } from './payment-transfer-wrapper.component';

@NgModule({
  declarations: [PaymentResponseWrapperComponent, PaymentTransferWrapperComponent],
  imports: [CommonModule, NotifyHeightDirective, CheckoutModule],
})
export class CheckoutWrappersModule {}
